import { QIcon_calendar_filled } from '@repo/icons/index'
import { useEventTracking } from '../../../helpers/gtmHelper'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'

const LessonFloatingButton = ({ isWebviewLocation = false }) => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const getFullUrl = useReturnFullUrl()
  const { sendClickEvent } = useEventTracking()

  const handleRouterClick = () => {
    sendClickEvent({ button_name: 'book_lessons' })
    router.push(urls.student.newPortal.lessons.schedule, {
      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
      appSendData: {
        url: getFullUrl(urls.webview.lessons.schedule),
      },
    })
  }
  return (
    <div className="pointer-events-auto relative">
      <button
        onClick={() => {
          handleRouterClick()
        }}
        className="z-[10] inline-flex items-center gap-6 whitespace-nowrap rounded-full border border-purple-600 bg-purple-600 py-[14px] px-[14px] font-bold text-white shadow-md hover:bg-purple-700 sm:py-14 sm:px-20"
      >
        <QIcon_calendar_filled className="h-[28px] w-[28px] sm:h-[20px] sm:w-[20px]" />
        <div className="hidden sm:block">{t(n_common.btn_book)}</div>
      </button>
    </div>
  )
}

export default LessonFloatingButton
